import { render, staticRenderFns } from "./CopyPanel.vue?vue&type=template&id=20374a98&scoped=true"
import script from "./CopyPanel.vue?vue&type=script&lang=js"
export * from "./CopyPanel.vue?vue&type=script&lang=js"
import style0 from "./CopyPanel.vue?vue&type=style&index=0&id=20374a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20374a98",
  null
  
)

export default component.exports